module.exports = __webpack_public_path__ + "static/media/LogicWedge5_4_2.96f1c518.png";